// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"405":"Weixin","463":"accountCenter"}[chunkId] || chunkId) + "." + {"405":"d057c83c","463":"e6eeb590","901":"324078cd"}[chunkId] + ".js";
};